import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Constants } from '../components/common/constants';
import { CompletePaymentRequest } from '../models/request/complete-payment-request.model';
import { EncryptServiceService } from './encrypt-service/encrypt-service.service';

@Injectable({
  providedIn: 'root'
})
export class PaymentService {
  OTP_HMAC_HEADER_NAME = 'AuthOTP';
  AUTHORIZATION_HEADER_NAME = 'Authorization';
  serverUrl:string
  constructor(
    private http: HttpClient,
    private _encryptService:EncryptServiceService,
  ) { 
    this.serverUrl = this._encryptService.decryptData(environment.BASE_URL);
  }
  sendOrder(request: CompletePaymentRequest): Observable<any> {
    const config = { headers: new HttpHeaders() };
    config.headers = config.headers.set('Content-Type',  'application/json');
    config.headers = config.headers.set('applicationSrc', 'fad');
    return this.http.post<any>(`${this.serverUrl}${Constants.endpoints.sendOrder}`, request, config);
  }

  checkPromo(code: string, amount: string, username: string): Observable<any> {
    const config = { headers: new HttpHeaders() };
    config.headers = config.headers.set('Content-Type',  'application/json');
    config.headers = config.headers.set('applicationSrc', 'fad');
    const body = {
      code: `${code}`,
      amounts: [
        {amount: `${amount}`}
      ],
      username: `${username}`
    };
    return this.http.post<any>(`${this.serverUrl}${Constants.endpoints.checkCode}`, body, config);
  }

}
